<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HClnDU/tc-custom/9781503611047.jpg?1699993425356" alt="This image is the cover for the book Love Drugs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love Drugs
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fascinating, game-changing scientific argument for the use of unconventional medicines by those struggling with matters of the heart.” ―Helen Fisher, author of <i>Anatomy of Love</i></b><br/><br/> Is there a pill for love? What about an “anti-love drug”, to help us get over an ex? This book argues that certain psychoactive substances, including MDMA—the active ingredient in Ecstasy—may help ordinary couples work through relationship difficulties and strengthen their connection. Others may help sever an emotional connection during a breakup. This book builds a case for conducting research into “love drugs” and “anti-love drugs” and explores the ethical implications for individuals and society. Western medicine ignores the interpersonal effects of drug-based interventions. Why are we still in the dark about the effects of these drugs on romantic partnerships? And how can we overhaul scientific research norms to take relationships more fully into account? <br/>  <br/> Ethicists Brian D. Earp and Julian Savulescu say that the time to think through such questions is now. Our most intimate connections are already being influenced by drugs we ingest for other purposes. Controlled studies are underway to see whether artificial brain chemicals can enhance couples therapy. <i>Love Drugs</i> arms us with the latest scientific knowledge and ethical tools that we can use to decide if these sorts of medications should be a part of our society. Or whether a chemical romance will be right for us.<br/><br/> “A fascinating account of a future that is starting to unfold right now.” ―Peter Singer, author of <i>Ethics in the Real World</i><br/><br/> “Earp and Savulescu show . . . how the drugs we have developed are expanding our capacities for connecting with each other” ―Clancy Martin, author of <i>Love and Lies</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian D Earp, Julian Savulescu
      </h2>
      
      <p class="authorDescription body article"><B>Brian D. Earp</B> is Associate Director of the Yale-Hastings Program in Ethics and Health Policy at Yale University and the Hastings Center and a Research Fellow at the Uehiro Centre for Practical Ethics at the University of Oxford. <B>Julian Savulescu</B> holds the Uehiro Chair in Practical Ethics and is Director of the Uehiro Centre for Practical Ethics at the University of Oxford.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stanford University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?019be886